// extracted by mini-css-extract-plugin
export default {"postWrapper":"Post_postWrapper__+c30j","postImage":"Post_postImage__jkYov","preview":"Post_preview__Nb9NZ"};